import Keycloak from 'keycloak-js';



let keycloak:Keycloak = null

/**
 * Costruisce l'oggetto Keycloak a partire dalla configurazione recuperata dal OS (tramite la API getOSConfig)
 */
export function BuildKeycloak(config: { url: string, realm: string, clientId: string }) {
	
	keycloak = new Keycloak(config)

	// Callback chiamata quando il token viene effettivamente rigenerato
	keycloak.onAuthRefreshSuccess = () => {
		console.log('Token aggiornato con successo');
		// Qui potresti aggiornare lo stato globale se salvi il token nel context (sconsigliato, meglio lasciarlo dentro l'oggetto keycloak)
	}

	keycloak.onAuthRefreshError = () => {
		console.error('Errore nel refresh del token');
		keycloak.login(); // Reindirizza al login
	}

	// Callback chiamata se il token scade e l'app è ferma (nessuna chiamata API)
	keycloak.onTokenExpired = () => {
		console.warn('Token scaduto!');
		// Puoi provare a rinnovarlo subito o aspettare la prossima chiamata API
		keycloak.updateToken(30).catch(() => keycloak.login());
	}
}

/**
 * Restituisce l'istanza di Keycloak, che deve essere stata costruita prima con BuildKeycloak
 */
export function GetKeycloak() {
	return keycloak
}

